export default {
	label: 'Dokument | Dokumendid',
	name: 'Nimetus',
	length: 'Suurus',
	added: 'Lisatud',
	addedUser: 'Lisanud kasutaja',
	reference: 'Viidatud',
	replace: 'Asenda',
	download: 'Lae alla',
	folderName: 'Kausta nimi',
	cantRemove: 'Ainult tühje kauste saab eemaldada!',
	cantAdd: 'Dokumendi lisamiseks valige esmalt asutus.',
	cantAdd2: 'Dokumendi lisamiseks puudub õigus!',
	with: 'dokumendiga',
	add: 'Lisa dokument',
	addURL: 'Lisa link',
	url: 'Link',
	editUrl: 'Muuda linki',
	select: 'Vali dokument',
	selectUrl: 'Vali link',
	successfullyMoved: 'Dokument on edukalt teisaldatud',
	successfullyReplaced: 'Dokument on edukalt asendatud',
	move: 'Teisalda',
	selectNewDirectory: 'Vali sihtkataloog',
	references: {
		title: 'Viited',
		empty: 'Viited puuduvad',
		deleteWarning:
			'Sellele on viidatud alljärgnevatelt objektidelt. Kustutamisel eemaldatakse need viited. Säilitamiseks tühista ja kasuta Asenda nuppu.',
		deleteAnyway: 'Kustuta siiski',
	},
	referenceTypes: {
		standard_method_meta_data: 'Meede',
		method: 'Meede',
		business_processes: 'Äriprotsess',
		assets: 'Vara',
		data_assets: 'Infovara',
		module_meta: 'Moodul',
		risk_meta: 'Risk',
		threat_meta: 'Oht',
		vulnerability_meta: 'Nõrkus',
	},
}
